<template>
  <div class="wrapper">
    <div class="main visual-1">
      <div v-if="isSuperAdmin" class="bck-btns home-back-nav">
        <a href="#" @click.prevent="$router.push('/super-admin-selection')">
          <i class="fa-solid fa-arrow-left"></i> Go Back
        </a>
      </div>
      <div class="container">
        <div class="wlcm">
          <div class="company-logo">
            <img src="@/assets/img/mamabots-app-logo.png" alt="Logo" />
            <img :src="logoPath" alt="Logo" />
          </div>
          <div class="tagline">
            <h3>Your Virtual</h3>
            <h2>Healthcare<br />Assistance</h2>
          </div>
          <p><router-link to="/appointments">Get Started</router-link></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AuthService } from "@/services/auth.service";
import dshLogo from "@/assets/img/dsh-logo.png";
import mamabotsLogo from "@/assets/img/mamabots-logo-edit.png";
import advEyeLogo from "@/assets/img/adv-logo-white-txt-1.png";

export default {
  name: "VisualOne",
  computed: {
    currentUser() {
      return this.$store?.state?.user?.currentUser || {};
    },
    isSuperAdmin() {
      return ["superadmin", "super_admin", "super-admin"].includes(
        this.currentUser.objectType,
      );
    },
    logoPath() {
      const hospitalId = localStorage.getItem("hospitalId") || "default";
      const logoMap = {
        "1234567890abcdef12345678": mamabotsLogo,
        "68d68a07d3f9b7819cd05e80": advEyeLogo,
        "68306098776144597cc2a7d8": dshLogo,
        default: mamabotsLogo,
      };
      return logoMap[hospitalId] || logoMap.default;
    },
  },
  methods: {
    async logout() {
      try {
        await AuthService.makeLogout(); // Ensure it is awaited

        // this.$store.commit("toast/NEW", {
        //   type: "success",
        //   message: "Logged Out Successfully!",
        // });

        // Wait for the toast message to show before redirecting
        setTimeout(() => {
          this.$router.push("/login");
        }, 1000);
      } catch (err) {
        console.error("Logout Error:", err);
        this.$store.commit("toast/NEW", {
          type: "error",
          message: "Logout failed. Please try again.",
        });
      }
    },
  },
};
</script>
<style scoped>
.company-logo {
  display: flex;
  justify-content: space-between;
  padding: 0 0 10px;
}

.company-logo img {
  width: 300px;
  object-fit: contain;
}

.home-back-nav {
  z-index: 10;
  justify-content: flex-start;
  pointer-events: none;
  margin-top: 10px;
}

.home-back-nav a {
  display: inline-flex;
  align-items: center;
  position: relative;
  z-index: 11;
  pointer-events: auto;
  cursor: pointer;
}
</style>
